module.exports = __webpack_public_path__ + "img/fffd238a869cd3b2b9f490806db1603f.png";